// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__18Vzi","title":"InfoRow_title__3rFuv"};